import React from 'react'
import { render } from 'react-dom'
import TaskBarTemplate from './TaskBar'

import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager';

export default class MultiTaskManager extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {}

    render(){
        return (
            <div class="row">
                <TaskBarTemplate />
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/index.jsx